import {Component, OnDestroy, OnInit} from '@angular/core';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {forEach} from '@angular/router/src/utils/collection';

@Component({
  selector: 'app-gelios-row-selection-field',
  templateUrl: './gelios-row-selection-field.component.html',
})
export class GeliosRowSelectionFieldComponent extends GeliosFieldBaseComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  constructor(
    protected translate: TranslateService,
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
  ) {
    super(translate);
  }

  ngOnInit() {
    super.ngOnInit();
    this.subscriptions.push(
      this.router.events.subscribe(
        e => {
          if (e instanceof NavigationEnd) {
            this.updateFieldValue();
          }
        }
      )
    );
    this.updateFieldValue();
  }

  private updateFieldValue() {
    const idString: string = this.activatedRoute.snapshot.params.id;
    const ids = idString.split(',');
    this.formGroup.controls[this.fieldName].setValue(ids);
  }

  count() {
    const value = this.formGroup.controls[this.fieldName].value;
    if (Array.isArray(value)) {
      return value.length;
    }
    return 0;
  }
  ngOnDestroy() {
    this.subscriptions.filter(s => !!s).forEach(s => s.unsubscribe());
  }
}
